import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-project_letter",
  "use": "icon-project_letter-usage",
  "viewBox": "0 0 28 28",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 28 28\" id=\"icon-project_letter\"><g stroke=\"currentColor\" fill=\"transparent\" stroke-width=\"2\"><rect x=\"1\" y=\"1\" width=\"26\" height=\"20\" rx=\"4\" transform=\"translate(0 3)\" /><path stroke-linejoin=\"round\" d=\"M2 5l11.913 9L26 5\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol